function addSearchSubmit () {
    const submit = document.getElementById('js-search-academy-button');
    const form = document.getElementById('js-search-academy-form');
    const searchBox = document.getElementById('search-academy-filter');
    if (submit && form) {
      submit.addEventListener("click", function () {
        const filterUrl = getSubmitUrlFilter();
        document.location = window.location.origin + window.location.pathname + getSearchUrl(searchBox.value, filterUrl);
      });
    }
  }
  
  function addSearchFilterSubmit () {
    const radiobuttons = document.querySelectorAll('#js-search-academy-form .js-filter-radiobutton');
    const searchBox = document.getElementById('search-academy-filter');
  
    for(let i = 0; i < radiobuttons.length; i++) {
      const item = radiobuttons[i];
      item.addEventListener("click", function () {
        const filterUrl = getSubmitUrlFilter();
        document.location = window.location.origin + window.location.pathname + getSearchUrl(searchBox.value, filterUrl);
      });
    }
  }
  
  function addSearchReset () {
    const reset = document.getElementById('js-reset-academy-button');
    if (reset) {
      reset.addEventListener("click", function () {
        document.location = window.location.origin + window.location.pathname;
      });
    }
  }
  
  function getSubmitUrlFilter() {
    const checked = document.querySelectorAll('#js-search-academy-form input[type="radio"]:checked');
    let finalUrl = '';
  
    //get selected category
    const checkedDate = Array.from(checked).filter(x => x.name === 'date');
  
    if (checkedDate.length > 0) {
      finalUrl = 'date=' + checkedDate[0].value.toLowerCase();
    }
  
    return finalUrl;
  }
  
  function getSearchUrl(searchValue, filterUrl) {
    let searchUrl = '';
    if (searchValue !== '')
    {
      searchUrl = '?qa=' + searchValue;
    }
    if (filterUrl !== '')
    {
      if (searchUrl === '')
      {
        searchUrl = '?' + filterUrl;
      }
      else
      {
        searchUrl = searchUrl + '&' + filterUrl;
      }
    }
    return searchUrl;
  }
  
  if (document.getElementById('search-academy-filter') !== undefined && document.getElementById('search-academy-filter') !== null) {
    const filterUrl = getSubmitUrlFilter();
    document.querySelector('#search-academy-filter').addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
  
        document.location = window.location.origin + window.location.pathname + getSearchUrl(e.target.value, filterUrl);
      }
    });
  }

  
function scrollToSubmissions() {
  const componentAnchorLink = document.querySelector('.js-submissions');
  if (componentAnchorLink) {
      console.log('aaaa')
      const headerHeight = document.getElementsByClassName('navigation__bar')[0].clientHeight;
      const element = componentAnchorLink;
      element.style.marginTop = '-' + headerHeight + 'px';
  }
}
  
  addSearchSubmit();
  addSearchFilterSubmit();
  addSearchReset();
  scrollToSubmissions();